<template>
  <div>
    <px-view-header title="Projetos" title-class="font-weight-bold"
                    :breadcrumbs="breadcrumbs"/>
    <px-projeto-list-header :on-click-refresh="onClickRefresh"
                            :on-change-filter="onChangeFilter"/>
    <px-projeto-list :projetos="projetos"
                     :loading="loading"
                     :on-change-options="onChangeOptions"
                     :options-list="optionsList"
                     :footer-options="footerOptions"
                     @remove="onRemove"/>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import {
  RESET_PAGINATION,
  SET_FILTER_ACTION,
  SET_LIST_OPTIONS_ACTION,
  INIT_STATE_ACTION,
  SET_CURRENT_SESSION_STATE_ACTION,
} from '@/store/listagem-projetos/actions.type';
import paginationMixin from '@/mixins/pagination-mixin';
import ProjetoService from './projeto-service';
import ProjetoList from './ProjetoList.vue';
import ProjetoListHeader from './ProjetoListHeader.vue';

export default {
  mixins: [paginationMixin],
  data() {
    return {
      loading: false,
      breadcrumbs: [
        { text: 'Empresa' },
        { text: 'Projetos' },
      ],
      projetos: {
        content: [],
        total: 0,
      },
      optionsList: {},
    };
  },
  computed: {
    ...mapGetters('listagemProjetos', ['stringFilter', 'listOptions']),
    ...mapGetters('entidade', ['idEntidade']),
    ...mapGetters('user', ['user']),
  },
  methods: {
    ...mapActions('listagemProjetos', {
      resetPagination: RESET_PAGINATION,
      updateFilter: SET_FILTER_ACTION,
      updateOptions: SET_LIST_OPTIONS_ACTION,
      initState: INIT_STATE_ACTION,
      setCurrentSessionState: SET_CURRENT_SESSION_STATE_ACTION,
    }),
    onChangeFilter() {
      this.updateFilter(this.stringFilter);
      this.resetPage();
      this.getProjetos();
    },
    onChangeOptions(options) {
      this.optionsList = options;
      this.updateOptions(this.optionsToPage(this.listOptions, this.optionsList));
      this.getProjetos();
    },
    onClickRefresh() {
      this.getProjetos();
    },
    onRemove(item) {
      this.loading = true;
      ProjetoService.remover(item.id)
        .then(() => {
          this.$toast('projeto removido com sucesso', { color: 'success' });
          this.getProjetos();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    resetPage() {
      this.resetPagination();
      this.optionsList = this.pageToOptions(this.listOptions);
    },
    getProjetos() {
      this.loading = true;
      const { limit, offset } = this.listOptions;
      return ProjetoService.getList({
        limit,
        offset,
        query: this.buildQuery(this.listOptions),
      })
        .then((response) => {
          this.projetos = response.data;
        })
        .finally(() => {
          this.setCurrentSessionState({
            idCurrentEntidade: this.idEntidade,
            idCurrentUser: this.user.id,
          });
          this.loading = false;
        });
    },
  },
  created() {
    this.initState({
      idCurrentEntidade: this.idEntidade,
      idCurrentUser: this.user.id,
    });
    this.optionsList = this.pageToOptions(this.listOptions);
  },
  components: {
    pxProjetoList: ProjetoList,
    pxProjetoListHeader: ProjetoListHeader,
  },
};

</script>
